import { render, staticRenderFns } from "./ageBarChart.vue?vue&type=template&id=22152de2&scoped=true"
import script from "./ageBarChart.vue?vue&type=script&lang=js"
export * from "./ageBarChart.vue?vue&type=script&lang=js"
import style0 from "./ageBarChart.vue?vue&type=style&index=0&id=22152de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22152de2",
  null
  
)

export default component.exports